import { object, string, TypeOf } from 'yup';

export const ListRoleTemplateFilterSchema = object({
  name: string(),
});

export type ListRoleTemplateFilterType = TypeOf<
  typeof ListRoleTemplateFilterSchema
>;
